<div class="warp-compare" *ngIf="myAnswerByRecipient?.answer">
    <div class="answer" [ngClass]="{noWarp:question?.type?.id==eQuestionType.PhoneNumber}"
        *ngIf="question?.type?.id!=eQuestionType.QuestionsGroup else linkToGroup">
        <div class="current "
            [ngClass]="{compare: showComparison$(),wasChange:myAnswerByRecipient?.wasChange &&questionSource!=null }">
            <span *ngIf="question?.type?.id !=  eQuestionType.Signature "> {{ myAnswerByRecipient?.answer |
                answerSwitchType :
                question }}</span>
            <div *ngIf="question?.type?.id ==  eQuestionType.Signature " class="sign-warp">
                <img *ngIf="myAnswerByRecipient?.answer?.base64" [src]="myAnswerByRecipient?.answer?.base64">
                <div *ngIf="question?.isIncludeDate && myAnswerByRecipient?.answer?.dateAnswerNTZ" class="date"><span
                        translate>questionBoard.edit.signatureDate</span>: {{myAnswerByRecipient?.answer?.dateAnswerNTZ
                    |
                    queDate}}</div>
            </div>
        </div>
    </div>
    <div class="answer" [ngClass]="{noWarp:question?.type?.id==eQuestionType.PhoneNumber}"
        *ngIf="question?.type?.id!=eQuestionType.QuestionsGroup">
        <div class="source" *ngIf="showComparison$()">
            <div *ngIf="question?.type?.id !=  eQuestionType.Signature "> {{ myAnswerByRecipient?.answerSource |
                answerSwitchType :
                question }}</div>
            <div *ngIf="question?.type?.id ==  eQuestionType.Signature " class="sign-warp">
                <img *ngIf="myAnswerByRecipient?.answerSource?.base64"
                    [src]="myAnswerByRecipient?.answerSource?.base64">
                <div *ngIf="myAnswerByRecipient?.answerSource?.dateAnswerNTZ && question?.isIncludeDate" class="date"><span
                        translate>questionBoard.edit.signatureDate</span>:
                    {{myAnswerByRecipient?.answerSource?.dateAnswerNTZ |
                    queDate}}</div>
            </div>
        </div>
    </div>
</div>
<ng-template #linkToGroup>
    <div *ngIf="question?.type?.id==eQuestionType.QuestionsGroup" class="groupLink pointer" (click)="goToSummary()"
        translate>
        data.summary.groupLink
    </div>
</ng-template>